import { render, staticRenderFns } from "./info.vue?vue&type=template&id=6c8715d0&scoped=true"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"
import style0 from "./info.vue?vue&type=style&index=0&id=6c8715d0&prod&scoped=true&lang=css"
import style1 from "./info.vue?vue&type=style&index=1&id=6c8715d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8715d0",
  null
  
)

export default component.exports